import { createClient } from '@supabase/supabase-js';
import { Database } from 'src/types/db.types';

const supabaseUrl = 'https://fznqzgbwdqisfahiekiz.supabase.co';
// The anon key is public by design; RLS protects the data. Never put the
// service-role key here: it ships to every browser. Admin actions go through
// the admin-users Edge Function (src/services/supabase/adminUsers.ts).
const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ6bnF6Z2J3ZHFpc2ZhaGlla2l6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQ3ODA3MzIsImV4cCI6MjA1MDM1NjczMn0.5Bt9fOWyZYzEmMxoK3Wz1Kl6ZpiJccrbW3RdCrzkrHc';

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);
